// @owners { team: patients-team }
import { useEffect } from 'react';
import { faviconURLByDomain, updateFaviconLinks } from '~web/hooks/favicons';

const addMetaTags = (appName: string) => {
  const appNameMetaTag = document.createElement('meta');
  appNameMetaTag.setAttribute('name', 'application-name');
  appNameMetaTag.setAttribute('content', appName);
  document.head.appendChild(appNameMetaTag);

  const mobileWebAppTitleMetaTag = document.createElement('meta');
  mobileWebAppTitleMetaTag.setAttribute('name', 'apple-mobile-web-app-title');
  mobileWebAppTitleMetaTag.setAttribute('content', appName);
  document.head.appendChild(mobileWebAppTitleMetaTag);
};

/**
 * Sets the favicon and title for the browser tab based on the current domain
 */
export const useBrowserTab = () => {
  const currentHostName = window.location.hostname;

  useEffect(() => {
    switch (true) {
      case currentHostName.includes('patientrxauth'):
        updateFaviconLinks({ faviconURL: faviconURLByDomain['patientrxauth'] });
        document.title = 'Patient support program';
        addMetaTags('Alto');
        break;
      case currentHostName.includes('fuzehealth'):
        updateFaviconLinks({ faviconURL: faviconURLByDomain['fuzehealth'] });
        document.title = 'Fuze Health | Get your prescriptions delivered';
        addMetaTags('Fuze Health');
        break;
      default:
        document.title = 'Alto Health | Get your prescriptions delivered';
        addMetaTags('Alto');
        break;
    }
  }, [currentHostName]);
};
